import {useEffect, useState} from "react";
import {genericListboxFetch} from "./DropdownDataProviders";
import {Globals} from "root/DataFunctions/BaseDataFns";

const useListboxFetch = ({url, keyFieldName, labelFieldName, additionalFields, filterFn, mapFn, postProcessingFn}) =>
{
    const [data, setData] = useState({loading: true, items: []});

    useEffect(() =>
    {
        setData({loading: true, items: []});

        if (url !== null)
        {
            genericListboxFetch({url: Globals.APIFolder + url, keyFieldName, labelFieldName, filterFn, mapFn, postProcessingFn, additionalFields }).then((response) =>
            {
                setData({loading: false, items: response});
            });
        }
        else
        {
            setData({loading: false, items: []});
        }
    }, [url]);

    return [data.loading, data.items]
}

export default useListboxFetch;